<mat-sidenav-container class="container">
  <mat-sidenav mode="side" opened class="sidenav">
    <a routerLink="/home"><img src="assets/img/sidebar-menu/docformative-logo.svg" /></a>
    <app-menu></app-menu>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
